
import constant from '../../constant';

const loadDownloadScene = (payload = '') => ({
    type: constant.DOWNLOADBAR.DOWNLOAD_SCENE,
    payload
});
const loadDownLoadStatus = (payload = '') => ({
    type: constant.DOWNLOADBAR.DOWNLOAD_STATUS,
    payload
});
const loadProgressValue = (payload = '') => ({
    type: constant.DOWNLOADBAR.PROGRESS_VALUE,
    payload
});
const setDownloadBarActive = (payload = false) => ({
    type: constant.DOWNLOADBAR.BAR_ACTIVE,
    payload
});


export default {
    loadDownloadScene,
    loadDownLoadStatus,
    loadProgressValue,
    setDownloadBarActive
}